<template>
  <li
    class="col-span-1 flex items-center justify-center bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden select-none"
  >
    <div
      class="shrink-0 flex items-center justify-center w-6 h-6 text-gray-400 text-center text-xl leading-5 font-extralight bg-gray-200 px-3"
    >
      <word-icon :word="word"></word-icon>
    </div>

    <div class="flex-1 flex items-center px-2 py-0 truncate">
      <div
        class="w-11/12 flex items-center justify-start text-gray-900 leading-5 font-medium hover:text-gray-600 transition ease-in-out duration-150 truncate text-xs"
      >
        {{ word.word }}

        <!-- <svg
          v-if="word.positive"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-5 h-5 text-gray-400"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 6v12m6-6H6"
          />
        </svg> -->

        <!-- <svg
          v-if="!word.positive"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-5 h-5 text-gray-400"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
        </svg> -->
      </div>

      <zone-color-icons
        v-if="showClassification"
        :colors="word.zone_colors"
        :inline="true"
        :mini="true"
        class="w-3/12"
      ></zone-color-icons>
    </div>
  </li>
</template>

<script>
import ZoneColorIcons from '@/Pages/Markencode/Shared/ZoneColorIcons.vue';
import WordIcon from '@/Pages/Markencode/Shared/WordIcon.vue';

export default {
  components: {
    ZoneColorIcons,
    WordIcon,
  },

  props: {
    word: {
      required: true,
      default: Object,
    },
    showClassification: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  methods: {
    cancel() {
      return false;
    },
  },
};
</script>